export default __webpack_public_path__ + "static/favicon-512x512-2e31d338b4aa96aa2a0a024ac8949bc2.png";